import { useDispatch } from 'react-redux';
import { WeekNavigator } from '../../../../components';
import { selectedWeek } from '../../../../redux/slices/shiftSlice';
import { getStartOfWeek, formatLocalDate } from '../../../../utils/dateUtils';

/**
 * Component for navigating between weeks and displaying week information in the employee panel
 * @param {string} startOfWeekTimestamp - Timestamp representing the start of the week
 * @param {number} shiftCount - Number of shifts scheduled for the week
 * @param {number} startOfWeekIndex - Index representing the first day of the week (0 = Sunday)
 * @param {Function} onDateChange - Callback function when date changes
 */
const EmployeeWeekNavigator = ({ startOfWeekTimestamp, shiftCount, startOfWeekIndex, onDateChange }) => {
  const dispatch = useDispatch();

  const handleWeekChange = (date) => {
    const startOfWeek = getStartOfWeek(date, startOfWeekIndex);
    dispatch(selectedWeek(startOfWeek));
    onDateChange(date);
  };

  const startOfWeekString = formatLocalDate(startOfWeekTimestamp, {
    month: 'short',
    day: 'numeric',
  });

  return (
    <WeekNavigator
      noPadding
      noCalendar
      onWeekChange={handleWeekChange}
      subCaption={`${shiftCount} shifts scheduled`}
      renderTitle={() => `Week of ${startOfWeekString}`}
    />
  );
};

export default EmployeeWeekNavigator;
